"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactInfo = function (_Component) {
  (0, _inherits3.default)(ContactInfo, _Component);

  function ContactInfo() {
    (0, _classCallCheck3.default)(this, ContactInfo);
    return (0, _possibleConstructorReturn3.default)(this, (ContactInfo.__proto__ || (0, _getPrototypeOf2.default)(ContactInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContactInfo, [{
    key: "render",
    value: function render() {
      var sitowiseStyle = {
        color: "#79C143"
      };
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Yhteystiedot" }),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(
              "h1",
              { className: "h3" },
              "Yhteystiedot"
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Asiakaspalvelu"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Haluatko antaa meille palautetta tai kertoa miten jokin voisi olla paremmin? L\xE4het\xE4 meille viesti osoitteeseen",
              " ",
              _react2.default.createElement(
                "a",
                { href: "mailto:asiakaspalvelu@maaporssi.fi" },
                "asiakaspalvelu@maaporssi.fi"
              ),
              "."
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Myynti"
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                null,
                "Katariina Makkonen"
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "a",
                { href: "tel:+358444279803" },
                "044 427 9803"
              ),
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "a",
                { href: "mailto:asiakaspalvelu@maaporssi.fi" },
                "asiakaspalvelu@maaporssi.fi"
              )
            ),
            _react2.default.createElement(
              "h2",
              { className: "h4" },
              "Yhteistyo\u0308kumppanit, strategia ja markkinointiviestinta\u0308"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Jos mielessa\u0308si kytee yhteistyo\u0308 Maapo\u0308rssin kanssa, ota yhteytta\u0308. Kuulemme mielella\u0308mme ajatuksestasi. Tehda\u0308a\u0308n yhdessa\u0308 jotain uutta!"
            ),
            _react2.default.createElement(
              "h3",
              { className: "h5" },
              "Maap\xF6rssi"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Linnoitustie 6",
              _react2.default.createElement("br", null),
              "02600 Espoo",
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "a",
                { href: "mailto:asiakaspalvelu@maaporssi.fi" },
                "asiakaspalvelu@maaporssi.fi"
              )
            ),
            _react2.default.createElement(
              "h3",
              { className: "h5" },
              "Sitowise Oy"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Verkkolaskuoperaattorimme on Pagero (v\xE4litt\xE4j\xE4n tunnus 003723609900 tai PAGERO)."
            ),
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "b",
                null,
                "Verkkolaskuosoitteemme on:"
              ),
              _react2.default.createElement("br", null),
              "Sitowise Oy, y-tunnus 2335445-0",
              _react2.default.createElement("br", null),
              "OVT-tunnus 003723354450"
            )
          )
        )
      );
    }
  }]);
  return ContactInfo;
}(_react.Component);

exports.default = ContactInfo;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ContactInfo/ContactInfo.js
 ** module id = 1211
 ** module chunks = 0
 **/